import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import styles from './sub-header.module.scss'

interface IProps {
  backPath?: string
  title: React.ReactNode
  loading: boolean
  children: React.ReactNode
}

const SubHeader: FC<IProps> = ({ backPath, title, children, loading }: IProps) => {
  
  return (
    <div className={styles.header}>
      {!loading && <>
        <h3 className={styles.title}>
          {backPath ? <Link to={backPath} className='tw-flex tw-items-center'>
            {title}
          </Link> : title}
        </h3>
        <div className='tw-flex tw-ml-auto'>
          {children}
        </div>
      </>}
    </div>
  )
}

export default SubHeader